<template>
	<div class="main">
		<remote-js src="https://g.alicdn.com/de/prismplayer/2.8.2/aliplayer-min.js"></remote-js>
		<div class="logo">
			<img src="../img/ic26.png">
			<img src="../img/ic4.png">
		</div>
		<div class="title">
			<h1 class="font-2">南方之强</h1>
			<p>——厦门大学庆祝建校100周年文艺晚会</p>
		</div>
		<div class="video">
			<div class="prism-player" id="J_prismPlayer"></div>
		</div>
		<div class="news">
			<h1>节目单</h1>
			<b class="font-5" v-html="'序：&emsp;桃李天下（校友暖场）'"></b>
			<b class="font-5">开篇：大厦之门 缘起嘉庚</b>
			<p v-html="'&emsp;&emsp;1.开场《倒计时短片》'"></p>
			<p v-html="'&emsp;&emsp;2.实景表演《回望百年》'"></p>
			<p v-html="'&emsp;&emsp;3.情景表演《缘起嘉庚》'"></p>
			<p v-html="'&emsp;&emsp;4.情景朗诵《2963》'"></p>
			<p v-html="'&emsp;&emsp;5.交响乐《关峡第一交响曲序曲》'"></p>
			<p v-html="'&emsp;&emsp;6.开场舞 《南方之强》'"></p>
			<b class="font-5">第一篇章：创榛辟莽 广揽群贤</b>
			<p v-html="'&emsp;&emsp;7.歌队颂唱《启程》'"></p>
			<p v-html="'&emsp;&emsp;8.爱国精神讲述《燃情岁月》'"></p>
			<p v-html="'&emsp;&emsp;9.音舞诗画《我们都是追梦人》'"></p>
			<p v-html="'&emsp;&emsp;10.革命精神讲述《唱支山歌给党听》'"></p>
			<p v-html="'&emsp;&emsp;11.短片《乡愁》'"></p>
			<p v-html="'&emsp;&emsp;12.舞蹈《不负韶华》'"></p>
			<b class="font-5">第二篇章：弦歌不辍 砥砺南强</b>
			<p v-html="'&emsp;&emsp;13.歌队颂唱《山河无恙》'"></p>
			<p v-html="'&emsp;&emsp;14.情景表演《西迁长汀》'"></p>
			<p v-html="'&emsp;&emsp;15.自强精神讲述《我爱你中国》'"></p>
			<p v-html="'&emsp;&emsp;16.	舞蹈《自强不息》'"></p>
			<b class="font-5">第三篇章：止于至善  建业颂恩</b>
			<p v-html="'&emsp;&emsp;17.情景表演《脊梁》'"></p>
			<p v-html="'&emsp;&emsp;18.科学精神讲述《共和国之恋》'"></p>
			<p v-html="'&emsp;&emsp;19.短片《时间的温度》'"></p>
			<p v-html="'&emsp;&emsp;20.多类型节目《春华秋实》'"></p>
			<p v-html="'&emsp;&emsp;&emsp;《送别》'"></p>
			<p v-html="'&emsp;&emsp;&emsp;《友谊地久天长》'"></p>
			<p v-html="'&emsp;&emsp;&emsp;《黄河协奏曲》'"></p>
			<p v-html="'&emsp;&emsp;&emsp;《歌唱祖国》'"></p>
			<p v-html="'&emsp;&emsp;&emsp;《我们走在大路上》'"></p>
			<p v-html="'&emsp;&emsp;&emsp;《年轻朋友来相会》'"></p>
			<p v-html="'&emsp;&emsp;&emsp;《夜空中最亮的星》'"></p>
			<p v-html="'&emsp;&emsp;&emsp;《少年》'"></p>
			<p v-html="'&emsp;&emsp;&emsp;【特别设计】'"></p>
			<p v-html="'&emsp;&emsp;&emsp;《灯火里的中国》'"></p>
			<b class="font-5">尾声：凤凰花开  万里扬帆</b>
			<p v-html="'&emsp;&emsp;21.实景表演《亲爱的旅人啊》'"></p>
			<p v-html="'&emsp;&emsp;22.校主独白《跟着你到天边》'"></p>
			<p v-html="'&emsp;&emsp;23.无人机表演《凤凰花开》'"></p>
			<p v-html="'&emsp;&emsp;24.舞蹈《万里扬帆》'"></p>
			<p v-html="'&emsp;&emsp;25.齐颂《相聚在美丽的校园》'"></p>
		</div>
		<jm-wap-nav></jm-wap-nav>
	</div>
</template>
<script src="https://g.alicdn.com/de/prismplayer/2.8.2/aliplayer-min.js"></script>
<script>
import jmWapNav from '../components/jm_wap_nav.vue'
import remoteJs from '../components/remote_js.vue'
export default {
	data() {
		return {
		}
	},
	mounted() {
		this.checkPlay()
		document.body.style.overflow='';
	},
	methods: {
		checkPlay(){
			if(window.Aliplayer !== undefined)
				new Aliplayer({ id: "J_prismPlayer", autoplay: true, width:"100%", height:"100%", source : "https://vod.xmupress.com/de6026b8ffc44ceb8e587a8d3fce1f68/c075e2c0e7ef42e4876d4e14deec4494.m3u8", cover:'', isLive: false,rePlay: false, playsinline: true,preload: true,controlBarVisibility: "hover", useH5Prism: true,format:'m3u8', }); 
			else
				setTimeout(this.checkPlay,20)
		}
	},
	components:{
		jmWapNav,
		remoteJs
	}
}
</script>
<style scoped>
@import "https://g.alicdn.com/de/prismplayer/2.8.2/skins/default/aliplayer-min.css";
.main{
	padding-bottom: 4.95rem;
	background: url(../img/ic10.png) no-repeat center bottom;
	background-size: 18.75rem;
}
.logo{
	display: flex;
	justify-content: center;
	padding-top: 2.625rem;
}
.logo img{
	display: flex;
	height: 2.75rem;
}
.logo img:nth-child(1){
	margin-right: .575rem;
}
.title{
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top:1rem;
}
.title h1{
	font-size: 3.4rem;
	color: #d7412a;
}
.title p{
	font-size: .9rem;
	color: #000000;
	margin-top: .5rem;
	font-family: "黑体";
}
.video{
	padding: 0 .675rem;
	height: 11.175rem;
	margin-top: 1.425rem;
}
.news{
	color: #92443c;
	padding: 0 1.7rem;
	margin-top: 1.775rem;
}
.news h1{
	color: #d7412a;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 1.375rem;
	border:2px solid #D7412A;
	border-radius: .3rem;
	width: 6.375rem;
	height: 2rem;
	margin: 0 auto;
	margin-bottom: 1.675rem;
}
.news b{
	font-size: .95rem;
	display: flex;
	height: 1.75rem;
	align-items: center;
}
.news p{
	line-height: 1.4rem;
	font-size: .8rem;
}
.news font{
	font-size: .7rem;
	display: flex;
	align-items: center;
	height: 1.4rem;
}
.video{
	display: flex;
	align-items: center;
	justify-content: center;
	color: #92443c;
	font-size: 1rem;
}
</style>